import{a as c}from"./chunk-H26UAHYG.js";import{a as o,m as r}from"./chunk-HBP5N4FR.js";r();var a=t=>t.batchTransactions,l=c(a,t=>{let e=o({},t);return delete e._persist,e});export{a,l as b};
//# sourceMappingURL=chunk-5277NS27.js.map
